module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default panel-search"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.page.query.param.name),
      callback: function($$v) {
        _vm.$set(_vm.page.query.param, "name", $$v)
      },
      expression: "page.query.param.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "keycode",
      rawName: "v-keycode",
      value: ('ENTER'),
      expression: "'ENTER'"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.create
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('v-table', {
    ref: "table",
    attrs: {
      "page": _vm.page,
      "table-minheight": 450
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "linkmanName",
      "label": "联系人",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "linkmanTel",
      "label": "手机号",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "备注"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(row.remark) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createOn",
      "width": "140",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(row.createOn) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "操作",
      "fixed": 'right'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "title": "用户"
          },
          on: {
            "click": function($event) {
              return _vm.showDispatchUserManage(scope.row)
            }
          }
        }, [_c('icon', {
          attrs: {
            "name": "account"
          }
        })], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "title": "编辑"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "title": "删除"
          },
          on: {
            "click": function($event) {
              return _vm.del(scope.row, scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete red"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-dialog', {
    ref: "formDiag",
    attrs: {
      "title": "信息编辑"
    }
  }, [_c('form-panel', {
    on: {
      "saved": _vm.onFormSaved
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.formDiag.dispatch('submit')
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    ref: "userDiag",
    attrs: {
      "title": "渠道用户管理"
    }
  }, [_c('dispatch-user-manage')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b070558","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/act/promotionDispatchChannel/Manage.vue
// module id = 310
// module chunks = 0